export type QueryPersistenceMode = 'lookup' | 'none'

export type QueryPersistenceMeta = Record<string, unknown> & {
  persistence?: QueryPersistenceMode
}

export const LOOKUP_PERSISTENCE_META = {
  persistence: 'lookup',
} as const satisfies QueryPersistenceMeta
